<template>
  <div class="searchbox">
    <div class="search">
      <el-select v-model="value" @change="selectKeys" placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.label"
        ></el-option>
      </el-select>
      <div class="searchinput" style="float: left">
        <el-input v-model="keywords" placeholder="请输入关键词"></el-input>
      </div>
    </div>
    <div class="searchbtna" @click="searchKeys">检索</div>
    <a
      href="http://s1.drcnet.com.cn/search/SearchAdvanced.aspx"
      target="blank"
      class="searchbtnb"
      >检索中心</a
    >
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: "标题",
      keywords: "",
    };
  },
  props: {
    url: {
      type: Array, //type为Array,default为函数
      // default() {
      //   return [
      //     "hahaxixihehe" //默认初始值
      //   ];
      // }
    },
    options: {
      type: Array, //type为Array,default为函数
      default() {
        return [
          {
            value: "0",
            label: "全文",
          },
          {
            value: "1",
            label: "标题",
          },
          // {
          //   value: "2",
          //   label: "作者"
          // },
          {
            value: "3",
            label: "关键词",
          },
          // {
          //   value: "4",
          //   label: "来源"
          // }
        ];
      },
    },
  }, //用props属性进行传数据，此时子组件已经获取到list的数据了
  methods: {
    selectKeys(val) {
      this.value = val;
    },
    searchKeys() {
      if (this.keywords.length === 0) {
        this.$message({
          message: "请输入查询信息",
          type: "warning",
        });
        return;
      }
      let newscope;
      this.options.forEach((item) => {
        if (this.value === item.label) {
          newscope = item.value;
        }
      });
      window.open(
        this.url[0] + newscope + "^1^1^" + escape(this.keywords) + this.url[1]
      ); //弹出一个新页面
      this.keywords = "";
      this.value = "标题";
    },
  },
};
</script>

<style lang='less' scoped>
.searchbox {
  float: right;
  .search {
    height: 38px;
    float: left;
    margin-left: 15px;
    margin-top: 10px;
    .el-select {
      float: left;
      width: 75px;
      height: 100%;
    }
  }
  .searchbtna {
    width: 76px;
    background-color: #2783d2;
    border-right: 1px solid;
  }
  .searchbtnb {
    width: 91px;
    background-color: #27a0d2;
  }
  .searchbtna,
  .searchbtnb {
    margin-top: 10px;
    text-align: center;
    line-height: 36px;
    float: left;
    cursor: pointer;
    color: #fff;
    font-size: 14px;
  }
  /deep/.el-input__inner {
    height: 36px;
    line-height: 36px;
    color: #575757;
    border-radius: 0px;
    padding-right: 0px;
    padding: 0 8px;
  }
}
::v-deep .searchinput {
  width: 410px;
}
@media screen and (max-width: 769px) {
  .searchbox {
    min-width: 280px;
  }
  .search {
    width: 60%;
  }
  ::v-deep .searchinput {
    width: 79%;
  }
  .searchbtna{
    width: 11% !important;
  }
  .searchbtnb {
    width: 21% !important;
  }
}
</style>